// ⚠️ AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// This file is generated by openapi-typescript / RTK Query codegen
// Any manual changes will be overwritten on next generation
// Generated: 2026-10-27

/* eslint-disable */

import {
  SourceOfFunds,
  AccountPurpose,
  RequiredCompletedVerifiedRejected,
  ActiveInactiveDeleted,
  PrimaryContactRelationship,
  BusinessType,
  ApplicationState,
  ApplicationType,
  OtopRequestState,
  ChargeBearer,
  ScaMethod,
  BeneficiarySource,
  CopStatus,
  ComplianceCheckState,
  PricingAlert,
  PricingQuoteState,
  QuoteAmountType,
  TenorType,
  ProcessingState,
  WalletType,
  OnlineQuotationFlag,
  ProductType,
  OnlineTradingMode,
  AccountType,
  AccountState,
  AccountRole,
  CopMatchResult,
  BankTransactionState,
  PaymentWithdrawalState,
  InstructionState,
  LegalEntityType,
  OperationCode,
  OtopRequestResourceType,
  TimeFrame,
  CountrySortBy,
} from "../redux/services/generated/api";
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

// Unified with RTK Query enum for type compatibility
export { SourceOfFunds }

// Unified with RTK Query enum for type compatibility
export { AccountPurpose }

// Unified with RTK Query enum for type compatibility
export { RequiredCompletedVerifiedRejected }

export enum NotRequiredOptionalRequired {
  NOT_REQUIRED = "NOT_REQUIRED",
  OPTIONAL = "OPTIONAL",
  REQUIRED = "REQUIRED",
}

// Unified with RTK Query enum for type compatibility
export { ActiveInactiveDeleted }

// Unified with RTK Query enum for type compatibility
export { PrimaryContactRelationship }

// Unified with RTK Query enum for type compatibility
export { BusinessType }

// Unified with RTK Query enum for type compatibility
export { ApplicationState }

// Unified with RTK Query enum for type compatibility
export { ApplicationType }

// Unified with RTK Query enum for type compatibility
export { OtopRequestState }

// Unified with RTK Query enum for type compatibility
export { ChargeBearer }

// Unified with RTK Query enum for type compatibility
export { ScaMethod }

// Unified with RTK Query enum for type compatibility
export { BeneficiarySource }

// Unified with RTK Query enum for type compatibility
export { CopStatus }

// Unified with RTK Query enum for type compatibility
export { ComplianceCheckState }

// Unified with RTK Query enum for type compatibility
export { PricingAlert }

// Unified with RTK Query enum for type compatibility
export { PricingQuoteState }

// Unified with RTK Query enum for type compatibility
export { QuoteAmountType }

// Unified with RTK Query enum for type compatibility
export { TenorType }

// Unified with RTK Query enum for type compatibility
export { ProcessingState }

// Unified with RTK Query enum for type compatibility
export { WalletType }

// Unified with RTK Query enum for type compatibility
export { OnlineQuotationFlag }

// Unified with RTK Query enum for type compatibility
export { ProductType }

// Unified with RTK Query enum for type compatibility
export { OnlineTradingMode }

// Unified with RTK Query enum for type compatibility
export { AccountType }

// Unified with RTK Query enum for type compatibility
export { AccountState }

// Unified with RTK Query enum for type compatibility
export { AccountRole }

// Unified with RTK Query enum for type compatibility
export { CopMatchResult }

// Unified with RTK Query enum for type compatibility
export { BankTransactionState }

// Unified with RTK Query enum for type compatibility
export { PaymentWithdrawalState }

// Unified with RTK Query enum for type compatibility
export { InstructionState }

// Unified with RTK Query enum for type compatibility
export { LegalEntityType }

// Unified with RTK Query enum for type compatibility
export { OperationCode }

/**
 * OtopRequest.resourceType
 * Type of resource requiring OTOP verification
 */
// Unified with RTK Query enum for type compatibility
export { OtopRequestResourceType }

/**
 * TimeFrame
 * A query parameter indicating a frame of reference for dates
 */
// Unified with RTK Query enum for type compatibility
export { TimeFrame }

/**
 * CountrySortBy
 * Sort order for countries list
 * @default "ID"
 */
// Unified with RTK Query enum for type compatibility
export { CountrySortBy }

export interface BankAccountSummary {
  /** @format uuid */
  id: string;
  resourceType?: string;
  accountName: string;
  accountType?: string;
  accountNameConfirmation?: string;
  accountNumber?: string;
  nationalClearingCode?: string;
  nationalClearingCodeType?: string;
  nationalBankCode?: string;
  nationalBranchCode?: string;
  iban?: string;
  bic?: string;
  country: string;
  nickname?: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
}

export interface PaymentRail {
  /** Payment processor ID (raw code, e.g. "FP", "SWIFT", "SCTINST") */
  id: string;
  /** Human-readable name (e.g. "Faster Payments", "SWIFT", "SEPA Instant") */
  name: string;
}

export interface FiatSettlementMethod {
  /**
   * Settlement instruction ID
   * @format uuid
   */
  id: string;
  /**
   * Currency symbol
   * Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   * @pattern ^[A-Z]{3}$
   */
  currency: string;
  bankAccount: BankAccountSummary;
  /** Available payment rails resolved from PaymentProcessor on the BFF. Each entry contains the raw processor ID and human-readable name. The frontend uses the `id` field to check for specific rails (e.g. SWIFT). */
  rails: PaymentRail[];
  /** Payment reference that must be included in the bank transfer */
  reference?: string;
}

export interface NetworkInfo {
  /** Blockchain chain-id (CAIP-2 format) */
  id: string;
  /** Human-readable blockchain name */
  name: string;
  /** Blockchain namespace (e.g., eip155, bip122) */
  namespace: string;
}

export interface BlockchainSettlementMethod {
  /**
   * Settlement instruction ID
   * @format uuid
   */
  id: string;
  /**
   * Virtual asset ID for this settlement method
   * @format uuid
   */
  virtualAssetId: string;
  /** Product code (e.g., USDC, USDT, BTC) */
  product: string;
  /** Blockchain network name */
  network: string;
  /** Blockchain network code */
  networkCode: string;
  /** Wallet address */
  address: string;
  /** Optional nickname for the wallet */
  nickname?: string;
  /** Networks this customer can settle this product on, derived from their own settlement instructions — not every network where the asset exists in the catalogue */
  availableNetworks: NetworkInfo[];
}

export interface SettlementMethodsResponse {
  /** Fiat settlement methods (bank accounts) */
  fiat: FiatSettlementMethod[];
  /** Blockchain settlement methods (wallets) */
  blockchain: BlockchainSettlementMethod[];
}

export interface ProductBalance {
  /** Current balance amount */
  balance: number;
  /** Number of decimal places for the product */
  decimalPlaces: number;
  /**
   * Last transaction date. May be omitted if no transactions have occurred for this product.
   * @format date
   */
  lastDate?: string;
}

export interface BalancesResponse {
  /** Map of product code to balance information */
  balances: Record<string, ProductBalance>;
}

export interface OnlineQuotation {
  state: OnlineQuotationFlag;
  /**
   * Start time for trading (local-time)
   * @format time
   */
  startTime: string;
  /**
   * End time for trading (local-time)
   * @format time
   */
  endTime: string;
  /** Buy limit for trading */
  buyLimit: number;
  /** Sell limit for trading */
  sellLimit: number;
}

export interface TradableProduct {
  /** Product code */
  id: string;
  resourceType: ProductType;
  /** Whether trading is currently enabled via self-service */
  isTradable: boolean;
  tradingRestriction?: OnlineTradingMode;
  onlineQuotation?: OnlineQuotation;
}

export interface PayableProduct {
  /** Product code */
  id: string;
  resourceType: ProductType;
}

export interface CapabilitiesResponse {
  /** Products that can be traded */
  tradable: TradableProduct[];
  /** Products that can be used for payments */
  payable: PayableProduct[];
}

export interface DeliverableCountry {
  /** ISO 3166-1 Alpha-2 country code */
  id: string;
  /** Country name */
  name?: string;
}

export interface DeliverableCountriesResponse {
  /** List of countries available for payment delivery */
  data: DeliverableCountry[];
}

export interface BeneficialOwnerAddress {
  line1?: string;
  line2?: string;
  line3?: string;
  postTown?: string;
  postCode?: string;
  state?: string;
  country?: string;
}

export interface BeneficialOwnerPerson {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  address?: BeneficialOwnerAddress;
}

export interface BeneficialOwnerCorporation {
  /** @format uuid */
  id: string;
  name: string;
  /** ISO 3166-1 Alpha-2 country code */
  incorporationCountry: string;
  address?: BeneficialOwnerAddress;
}

export interface BeneficialOwnersResponse {
  /** Beneficial owners that are natural persons */
  people: BeneficialOwnerPerson[];
  /** Beneficial owners that are corporate entities */
  corporations: BeneficialOwnerCorporation[];
}

export interface Country {
  /** ISO 3166-1 Alpha-2 country code */
  id: string;
  /** Country name */
  name?: string;
  /** ISO 3166-1 Alpha-3 country code */
  alpha3Code?: string;
  /** ISO 3166-1 numeric code */
  numericCode?: number;
  /** Whether the country is in the Eurozone */
  eurozone?: boolean;
  /** Whether the country supports SEPA payments */
  sepa?: boolean;
  /** Whether payments can be delivered to this country (has payment profile and not banned) */
  deliverable: boolean;
  /** Whether residents of this country are allowed (not banned) */
  residents: boolean;
}

export interface CountriesResponse {
  /** List of countries */
  data: Country[];
}

export interface Address {
  line1?: string;
  line2?: string;
  line3?: string;
  city?: string;
  postTown?: string;
  postCode?: string;
  state?: string;
  country?: string;
}

export interface CustomerAccountProfileSummary {
  baseCurrency?: string;
}

export interface CustomerAccountDetail {
  /** @format uuid */
  id?: string;
  resourceType?: string;
  name?: string;
  /** External reference identifier */
  reference?: string;
  accountType?: AccountType;
  accountState?: AccountState;
  bookingEntityCodes?: string[];
  profile?: CustomerAccountProfileSummary;
  /** Resolved legal entity (person or corporation) that owns this account */
  resolvedLegalEntity?: {
    resourceType?: string;
    firstName?: string;
    lastName?: string;
    companyName?: string;
    addresses?: Record<string, Address>;
  };
}

export interface CustomerAccountUser {
  /** @format uuid */
  id?: string;
  resourceType?: string;
  reference?: string;
  customerAccount?: CustomerAccountDetail;
  relationship?: AccountRole;
  role?: AccountRole;
  trader?: boolean;
  confirmer?: boolean;
  riskAssessmentState?: ComplianceCheckState;
  termsAccepted?: ComplianceCheckState;
  emailAddress?: string;
  comment?: string;
}

export interface Self {
  /** @format uuid */
  id: string;
  /** @default "people" */
  resourceType: string;
  firstName: string;
  lastName: string;
  title?: string;
  middleNames?: string;
  /** @format date */
  dateOfBirth?: string;
  mobilePhone?: string;
  email?: string;
  addresses?: Record<string, Address>;
  customerAccounts: CustomerAccountUser[];
}

/** Contains error message */
export interface ExceptionDetail {
  /**
   * @format int32
   * @min 400
   * @default 400
   */
  status: number;
  /** @deprecated */
  error?: string;
  /**
   * Human readable description of the type of exception.
   * @example "Unsupported currency"
   */
  message?: string;
  /**
   * Human readable description of the exception instance.
   * @example ["Cannot purchase RUB"]
   */
  messages?: string[];
  /** The name of the service that was the original source or cause of events, commands, or exceptions. */
  origin: string;
  /**
   * Type of the exception unique to the originating service. Imparts no
   * information for a particular exception instance. Intended to be used with
   * the parameters property for localisation of the exception message.
   * @default "service-exception"
   * @example "currency-not-supported"
   */
  type: string;
  /** Correlation id for the request. This is the OpenTelemetry span id. */
  spanId?: string;
  /** @example {"currency":"RUB"} */
  parameters?: Record<string, string>;
}

export interface ProductBase {
  resourceType: string;
  name: string;
  description?: string;
  /**
   * @format int32
   * @min 0
   * @max 2
   */
  decimalPlaces: number;
}

export type Product = {
  /**
   * Product symbol
   * Id of a product entity managed by the `@jftechnology/ledger` service
   * @pattern ^[A-Z]{3,16}$
   */
  code: string;
} & ProductBase;

export interface ProductPage {
  data: Product[];
  /** Metadata for a page of resources. This supports cursor based pagination suitable for navigating a growing or streaming data collection via the  'startCursor' and 'endCursor'  properties. Search endpoints that wish to offer  cursor based pagination queries need to accept 'page[cursor]' and 'page[size]'  query parameters. Clients querying such an endpoint can then include one of the cursors together with a page size to request the previous or next page */
  meta?: PageMetadata;
}

export interface ResolvedStatement {
  /**
   * Ledger Account Code
   * Code of a `ledger-account` entity managed by the `@jftechnology/ledger` service.
   * @format int32
   * @min 1
   */
  ledgerCode: number;
  /**
   * Product symbol
   * Id of a product entity managed by the `@jftechnology/ledger` service
   * @pattern ^[A-Z]{3,16}$
   */
  product: string;
  /** The resource type of the product as defined in its respective `Product.resourceType` property. */
  productType: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
  openingBalance: number;
  closingBalance: number;
  /**
   * The id of a booking entity
   * @maxLength 4
   */
  bookingEntity?: string;
  /**
   * UUID of a bank account
   * UUID of a bank account entity managed by the `@jftechnology/journal-payment` service.
   * @format uuid
   */
  bankAccount?: string;
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount?: string;
  /**
   * UUID of a customer subaccount
   * The system wide UUID of a customer subaccount.
   * @format uuid
   */
  customerSubaccount?: string;
  entries?: LedgerEntryResolved[];
}

export interface LedgerEntry {
  /** Source journal indicator */
  journal: string;
  /**
   * ID of source journal entry
   * @format uuid
   */
  uuid: string;
  /**
   * Index of ledger entry for the journal entry
   * @format int32
   */
  item: number;
  /**
   * Ledger Account Code
   * Code of a `ledger-account` entity managed by the `@jftechnology/ledger` service.
   * @format int32
   * @min 1
   */
  ledgerCode: number;
  /**
   * Product symbol
   * Id of a product entity managed by the `@jftechnology/ledger` service
   * @pattern ^[A-Z]{3,16}$
   */
  product: string;
  /** The resource type of the product as defined in its respective `Product.resourceType` property. */
  productType: string;
  /**
   * Non-negative amount of the related product
   * @min 0
   */
  credit: number;
  /**
   * Non-negative amount of the related product
   * @min 0
   */
  debit: number;
  /** @format date */
  bookDate: string;
  /** @format date */
  valueDate: string;
  /**
   * The id of a booking entity
   * @maxLength 4
   */
  bookingEntity?: string;
  /**
   * UUID of a bank account
   * UUID of a bank account entity managed by the `@jftechnology/journal-payment` service.
   * @format uuid
   */
  bankAccount?: string;
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount?: string;
  /**
   * UUID of a customer subaccount
   * The system wide UUID of a customer subaccount.
   * @format uuid
   */
  customerSubaccount?: string;
  /**
   * UUID of an ABAC Silo
   * The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC),
   * @format uuid
   */
  silo?: string;
  /** Running balance */
  balance?: number;
  /** @maxLength 32 */
  reason?: string;
  /** @maxLength 255 */
  comment?: string;
}

/** Payment resolution data trimmed to fields used by ledger UI */
export interface FilteredResolvedPaymentData {
  /** Beneficiary UUID (fallback when resolution fails) */
  beneficiary?: FilteredFiatBeneficiary | string;
  feeAmount?: number;
  feeCurrency?: string;
  paymentState?: PaymentWithdrawalState;
  remittanceInformation?: string;
  /** Free-form reason/description for the payment (e.g., "Q3 invoice settlement"). */
  paymentReason?: string;
  /** Coded purpose classification (e.g., "goods_sold"). Translated via PaymentReason dictionary on the frontend. */
  purposeCode?: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  reference?: string;
  /** @format date */
  valueDate?: string;
  instructionState?: InstructionState;
}

/** Debit bank account trimmed to ledger-displayed fields */
export interface FilteredDebitBankAccount {
  accountName?: string;
}

/** Related payment trimmed to ledger-displayed fields */
export interface FilteredRelatedPayment {
  /** Beneficiary UUID (fallback when resolution fails) */
  beneficiary?: FilteredFiatBeneficiary | string;
  remittanceInformation?: string;
  feeAmount?: number;
  feeCurrency?: string;
  /** Free-form reason/description for the related payment. */
  paymentReason?: string;
  /** Coded purpose classification for the related payment. Translated via PaymentReason dictionary on the frontend. */
  purposeCode?: string;
}

/** Bank transaction resolution data trimmed to fields used by ledger UI */
export interface FilteredResolvedBankTransaction {
  transactionState?: BankTransactionState;
  /** @format date-time */
  transactionTime?: string;
  narrative?: string[];
  reference?: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  /** @format date */
  valueDate?: string;
  /** Debit bank account trimmed to ledger-displayed fields */
  debitBankAccount?: FilteredDebitBankAccount;
  /** Related payment trimmed to ledger-displayed fields */
  resolvedRelatedPayment?: FilteredRelatedPayment;
}

/** Blockchain beneficiary trimmed to ledger-displayed fields */
export interface FilteredBlockchainBeneficiary {
  /** Legal entity trimmed to display-name fields only */
  legalEntity?: FilteredLegalEntity;
  nickname?: string;
  resourceType?: string;
  /** Blockchain wallet trimmed to address and network info */
  wallet?: FilteredBlockchainWallet;
}

/** Blockchain withdrawal resolution data trimmed to ledger UI fields */
export interface FilteredResolvedBlockchainWithdrawal {
  /** Beneficiary UUID (fallback when resolution fails) */
  beneficiary?: FilteredBlockchainBeneficiary | string;
  withdrawalState?: PaymentWithdrawalState;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  reference?: string;
  /** @format date */
  valueDate?: string;
  /** Withdrawal fee with amount and product */
  fee?: FilteredBlockchainWithdrawalFee;
  instructionState?: InstructionState;
}

/** Network-fee wallet with resolved address and blockchain */
export interface FilteredResolvedBlockchainTransactionNetworkFeeWallet {
  address: string;
  /** Blockchain network trimmed to display fields with address-only explorer */
  blockchain?: FilteredBlockchainNetwork;
}

/** Network fee for a blockchain transaction */
export interface FilteredResolvedBlockchainTransactionNetworkFee {
  /** Network-fee wallet with resolved address and blockchain */
  wallet: FilteredResolvedBlockchainTransactionNetworkFeeWallet;
}

/** Single credit/debit transfer trimmed to wallet address only */
export interface FilteredResolvedBlockchainTransactionTransfer {
  creditWallet?: {
    address?: string;
  };
  debitWallet?: {
    address?: string;
  };
}

/** Blockchain transaction resolution data trimmed to ledger UI fields */
export interface FilteredResolvedBlockchainTransaction {
  transactionState?: BankTransactionState;
  /** @format date-time */
  transactionTime?: string;
  txHash?: string;
  reference?: string;
  /** @format date */
  valueDate?: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  /** Blockchain network trimmed to display fields with address-only explorer */
  blockchain?: FilteredBlockchainNetwork;
  /** Network fee for a blockchain transaction */
  networkFee?: FilteredResolvedBlockchainTransactionNetworkFee;
  transfers?: FilteredResolvedBlockchainTransactionTransfer[];
}

export interface TradeFiltered {
  /** Counter amount */
  counterAmount?: number;
  /** Base amount */
  baseAmount?: number;
  /** Base currency code */
  baseCurrency?: string;
  /** Counter currency code */
  counterCurrency?: string;
  /** Whether the trade is settled */
  settled?: boolean;
  /**
   * Value date
   * @format date
   */
  valueDate?: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  /** Trade reference */
  reference?: string;
}

export interface FilteredPosting {
  /** @format date */
  valueDate?: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  reference?: string;
  amount?: number;
  currency?: string;
  comment?: string;
}

export type LedgerEntryResolved = LedgerEntry & {
  /** Resolved journal data based on journal type. The shape depends on the entry's journal field. */
  resolvedData?:
    | null
    | FilteredResolvedPaymentData
    | FilteredResolvedBankTransaction
    | FilteredResolvedBlockchainWithdrawal
    | FilteredResolvedBlockchainTransaction
    | TradeFiltered
    | FilteredPosting;
};

export interface ResolvedLedgerEntryPage {
  data: LedgerEntryResolved[];
  /** Metadata for a page of resources. This supports cursor based pagination suitable for navigating a growing or streaming data collection via the  'startCursor' and 'endCursor'  properties. Search endpoints that wish to offer  cursor based pagination queries need to accept 'page[cursor]' and 'page[size]'  query parameters. Clients querying such an endpoint can then include one of the cursors together with a page size to request the previous or next page */
  meta?: PageMetadata;
}

export interface CreateOtopRequest {
  /**
   * Optional content body of the required SMS message
   * @example "Your one time only password is %s"
   */
  messageFormat?: string;
}

export interface VerifyOtopRequest {
  /**
   * 4 digit OTOP sent to a recipient.
   * @pattern ^\d{4}$
   */
  otop: string;
}

export interface OtopRequestResponse {
  /**
   * Unique id for the OTOP request
   * @format uuid
   */
  id: string;
  state: OtopRequestState;
  /**
   * Number of failed verification attempts
   * @format int32
   */
  failures: number;
  /**
   * Time indicating when OTOP will expire
   * @format date-time
   */
  expiryTime: string;
}

export interface CopCheckRequest {
  beneficiaryType: LegalEntityType;
  /**
   * ISO 4217 currency code
   * @pattern ^[A-Z]{3}$
   * @example "GBP"
   */
  currency: string;
  /**
   * ISO 3166-1 alpha-2 country code
   * @pattern ^[A-Z]{2}$
   * @example "GB"
   */
  country: string;
  /** Name of the account holder to verify */
  accountName: string;
  /** Bank account number */
  accountNumber?: string;
  /** National clearing code (e.g., sort code in UK) */
  nationalClearingCode?: string;
  /** International Bank Account Number */
  iban?: string;
}

export interface CopCheckResponse {
  status: CopMatchResult;
  /** Human-readable description of the status */
  statusDescription?: string;
  /** Name of the account holder as registered with the bank */
  bankAccountHolderName?: string;
  /** Name of the bank */
  bankName?: string;
  /** Registration ID from the provider */
  providerRegistrationId?: string;
  /** The name that was matched (typically used for CLOSE_MATCH status) */
  matchedName?: string;
}

export interface Confirmer {
  /**
   * Unique identifier of the person who can confirm
   * @format uuid
   */
  id: string;
  /** First name of the confirmer */
  firstName: string;
  /** Last name of the confirmer */
  lastName: string;
}

export interface ConfirmationRequirement {
  /**
   * Unique identifier for the resource
   * @format uuid
   */
  id: string;
  /** Type of resource requiring confirmation */
  resourceType: string;
  /** Whether Strong Customer Authentication is required */
  scaRequired: boolean;
  /**
   * Number of confirmers required
   * @format int32
   * @min 0
   */
  confirmersRequired: number;
  /** Array of confirmer objects for users who have already confirmed */
  currentConfirmers: Confirmer[];
  /** Array of confirmer objects for users who are available to confirm */
  availableConfirmers: Confirmer[];
}

/** Request body for confirming or rejecting a payment instruction. */
export interface ConfirmInstructionRequest {
  /** Whether to confirm or reject the instruction */
  confirmed: boolean;
}

/** Payment resource with internal/sensitive fields stripped for BFF consumers. */
export interface PaymentStripped {
  /** @format uuid */
  id: string;
  resourceType: string;
  reference: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta: ResourceMetadata;
  /** Unique key of this transaction in the downstream source */
  correlationId?: string;
  paymentState: PaymentWithdrawalState;
  /**
   * Currency symbol
   * Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   * @pattern ^[A-Z]{3}$
   */
  currency: string;
  amount: number;
  /**
   * UUID of the beneficiary
   * @format uuid
   */
  beneficiary: string;
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount: string;
  customerReference?: string;
  /** @format date */
  paymentDate: string;
  /** @format date */
  valueDate?: string;
  /** @format date-time */
  acceptableUntil?: string;
  chargeCode?: ChargeBearer;
  operationCode?: OperationCode;
  remittanceInformation?: string;
  paymentReason?: string;
  purposeCode?: string;
  ultimateBeneficiary?: string;
  /**
   * Currency symbol
   * Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
   * @pattern ^[A-Z]{3}$
   */
  feeCurrency?: string;
  feeAmount?: number;
  instructionState: InstructionState;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  instructionOriginator?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  instructionPlacer?: string;
  instructionConfirmers?: string[];
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  /**
   * Correlation UUID for the processing operation
   * @format uuid
   */
  processingId?: string;
  /** @format uuid */
  processedBankTransaction?: string;
  comment?: string;
}

/** Paginated list of payments with internal fields stripped. */
export interface PaymentStrippedPage {
  data: PaymentStripped[];
  /** Metadata for a page of resources. This supports cursor based pagination suitable for navigating a growing or streaming data collection via the  'startCursor' and 'endCursor'  properties. Search endpoints that wish to offer  cursor based pagination queries need to accept 'page[cursor]' and 'page[size]'  query parameters. Clients querying such an endpoint can then include one of the cursors together with a page size to request the previous or next page */
  meta?: PageMetadata;
}

export interface ConfirmWithdrawalInstructionRequest {
  /** Whether to confirm or reject the withdrawal instruction */
  confirmed: boolean;
}

/** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
export interface ResourceMetadata {
  /**
   * Time and date this resource was created.
   * @format date-time
   */
  createTime?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  createUser?: string;
  /**
   * Time and date this resource was last updated.
   * @format date-time
   */
  updateTime?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  updateUser?: string;
  /** Describes reason for the update. */
  updateComment?: string;
  /**
   * Zero based count of updates.
   * @format int32
   * @min 0
   */
  version?: number;
  state?: ActiveInactiveDeleted;
}

export interface BlockchainWithdrawalStripped {
  /**
   * Journal UUID of a blockchain withdrawal
   * @format uuid
   */
  id: string;
  resourceType: string;
  reference: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta: ResourceMetadata;
  withdrawalState: PaymentWithdrawalState;
  /**
   * UUID of a withdrawal beneficiary entity
   * @format uuid
   */
  beneficiary: string;
  amount: number;
  customerReference?: string;
  /** @format date */
  withdrawalDate: string;
  /** @format date */
  valueDate?: string;
  /** @format date-time */
  acceptableUntil?: string;
  fee?: {
    product?: string;
    amount?: number;
  };
  instructionState: InstructionState;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  instructionOriginator?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  instructionPlacer?: string;
  instructionConfirmers?: string[];
  scaMethod?: ScaMethod;
  /** @format uuid */
  processingId?: string;
  comment?: string;
}

export interface PaymentReason {
  /** Unique identifier (will be backend-provided ID in future) */
  id: string;
  /** Translation key for frontend i18n lookup */
  name: string;
  /** Human-readable fallback if translation unavailable */
  description: string;
}

/** Filtered ticker price with only frontend-needed fields */
export interface FilteredTickerPrice {
  /** Bid price */
  bid: number;
  /** Ask price */
  ask: number;
  /** Base product symbol */
  baseProduct: string;
  /** Counter product symbol */
  counterProduct: string;
}

export interface FilteredTickerPricePage {
  data: FilteredTickerPrice[];
}

/** Bank account details associated with a beneficiary, including routing and identification data. */
export interface AccountBankAccount {
  /**
   * UUID of the bank account
   * @format uuid
   */
  id?: string;
  /** Resource type */
  resourceType?: string;
  /** Account name */
  accountName: string;
  accountType?: BeneficiarySource;
  accountNameConfirmation?: CopStatus;
  /** Account number */
  accountNumber?: string;
  /** National clearing code */
  nationalClearingCode?: string;
  /** National clearing code type */
  nationalClearingCodeType?: string;
  /** National bank code */
  nationalBankCode?: string;
  /** National branch code */
  nationalBranchCode?: string;
  /** IBAN */
  iban?: string;
  /** BIC code */
  bic?: string;
  /** Country code */
  country: string;
  /** Nickname */
  nickname?: string;
  /** Beneficial owners */
  beneficialOwners?: {
    /** @format uuid */
    id: string;
    resourceType: string;
  }[];
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
}

/** Postal address of a beneficiary (person or corporation). */
export interface AccountBeneficiaryAddress {
  /** First name (required for PERSON type) */
  firstName?: string;
  /** Last name (required for PERSON type) */
  lastName?: string;
  /** Corporation name (required for CORPORATION type) */
  corporationName?: string;
  /** Address line 1 */
  line1?: string;
  /** Address line 2 */
  line2?: string;
  /** Address line 3 */
  line3?: string;
  /** Post town */
  postTown?: string;
  /** Post code */
  postCode?: string;
  /** State */
  state?: string;
  /** Country code */
  country?: string;
}

/** Default payment parameters for a beneficiary (charge code, operation code, remittance info). */
export interface AccountBeneficiaryDefaults {
  chargeCode?: ChargeBearer;
  operationCode?: OperationCode;
  /** Default intermediary */
  intermediary?: string;
  /** Default remittance information */
  remittanceInformation?: string;
  /**
   * Default customer subaccount
   * @format uuid
   */
  customerSubaccount?: string;
  /** Default purpose code */
  purposeCode?: string;
}

/** Verification status of a beneficiary, including CoP (Confirmation of Payee) results. */
export interface AccountBeneficiaryVerification {
  nameConfirmation?: CopStatus;
  /** Timestamp of last verification check */
  lastChecked?: string;
  /** Verification comment */
  comment?: string;
}

/** Request body for creating a new payment beneficiary. A new beneficiary is untrusted until the OTP trust step marks it trusted, and its risk assessment state is set by the accounts service, so the request carries neither. verification carries the name-confirmation result the web got from the confirmation-of-payee check. */
export interface CreateBeneficiaryRequest {
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount: string;
  /** Bank account details associated with a beneficiary, including routing and identification data. */
  bankAccount: AccountBankAccount;
  /** Currency code */
  currency: string;
  beneficiaryType: LegalEntityType;
  /** Customer reference */
  customerReference?: string;
  /** Beneficiary name */
  name?: string;
  /** Nickname */
  nickname?: string;
  /** Postal address of a beneficiary (person or corporation). */
  address?: AccountBeneficiaryAddress;
  /** Default payment parameters for a beneficiary (charge code, operation code, remittance info). */
  defaults?: AccountBeneficiaryDefaults;
  /** Whether this beneficiary is active */
  active?: boolean;
  /** Comment */
  comment?: string;
  /** Verification status of a beneficiary, including CoP (Confirmation of Payee) results. */
  verification?: AccountBeneficiaryVerification;
}

/** Minimal mutation response containing only the resource identifier. Used for fire-and-forget mutations where the client relies on cache invalidation rather than the response body. */
export interface IdOnlyResponse {
  /** @format uuid */
  id: string;
}

/** Bank account trimmed to fields the frontend displays. */
export interface FilteredBankAccount {
  /** Country code */
  country?: string;
  /** Account name */
  accountName?: string;
  /** Account number */
  accountNumber?: string;
  /** National clearing code */
  nationalClearingCode?: string;
  /** IBAN */
  iban?: string;
  /** BIC code */
  bic?: string;
}

/** Beneficiary address trimmed to fields the frontend displays. */
export interface FilteredBeneficiaryAddress {
  /** First name */
  firstName?: string;
  /** Last name */
  lastName?: string;
  /** Corporation name */
  corporationName?: string;
  /** Address line 1 */
  line1?: string;
  /** Address line 2 */
  line2?: string;
  /** Post town */
  postTown?: string;
  /** Post code */
  postCode?: string;
  /** State */
  state?: string;
  /** Country code */
  country?: string;
}

/** Beneficiary defaults trimmed to fields the frontend uses. */
export interface FilteredBeneficiaryDefaults {
  /** Default remittance information */
  remittanceInformation?: string;
  /** Default purpose code */
  purposeCode?: string;
  operationCode?: OperationCode;
  chargeCode?: ChargeBearer;
}

/** Beneficiary verification trimmed to fields the frontend displays. */
export interface FilteredBeneficiaryVerification {
  nameConfirmation?: CopStatus;
}

/** Beneficiary detail trimmed to fields the frontend displays. */
export interface FilteredBeneficiaryDetail {
  /**
   * UUID of the beneficiary
   * @format uuid
   */
  id: string;
  /** Resource type */
  resourceType?: string;
  /** Nickname */
  nickname?: string;
  /** Currency code */
  currency: string;
  beneficiaryType: LegalEntityType;
  /** Whether this beneficiary is trusted */
  trusted?: boolean;
  /** Bank account trimmed to fields the frontend displays. */
  bankAccount?: FilteredBankAccount;
  /** Beneficiary address trimmed to fields the frontend displays. */
  address?: FilteredBeneficiaryAddress;
  /** Beneficiary defaults trimmed to fields the frontend uses. */
  defaults?: FilteredBeneficiaryDefaults;
  /** Beneficiary verification trimmed to fields the frontend displays. */
  verification?: FilteredBeneficiaryVerification;
}

/** Request body for updating an existing payment beneficiary. The update is partial: a field the request leaves out, including one inside address or defaults, keeps the stored value, and a string field sent as an empty string ("") clears it. Trust is granted only through the OTP trust step, and the risk assessment state and name-confirmation verification are held by the accounts service, so an update keeps the stored values of all three and the request carries none of them. */
export interface UpdateBeneficiaryRequest {
  beneficiaryType: LegalEntityType;
  /** Customer reference */
  customerReference?: string;
  /** Beneficiary name */
  name?: string;
  /** Nickname */
  nickname?: string;
  /** Postal address of a beneficiary (person or corporation). */
  address?: AccountBeneficiaryAddress;
  /** Default payment parameters for a beneficiary (charge code, operation code, remittance info). */
  defaults?: AccountBeneficiaryDefaults;
  /** Whether this beneficiary is active */
  active?: boolean;
  /** Comment */
  comment?: string;
}

/** Payment with resolved beneficiary object */
export interface ResolvedPayment {
  /** @format uuid */
  id?: string;
  resourceType?: string;
  reference?: string;
  paymentState?: PaymentWithdrawalState;
  currency?: string;
  amount?: number;
  /** Resolved beneficiary object (full object instead of UUID) */
  beneficiary?: {
    /** @format uuid */
    id?: string;
    resourceType?: string;
    name?: string;
    nickname?: string;
    customerReference?: string;
    currency?: string;
    beneficiaryType?: LegalEntityType;
    /** Bank account details associated with a beneficiary, including routing and identification data. */
    bankAccount?: AccountBankAccount;
    trusted?: boolean;
    active?: boolean;
  };
  /** @format uuid */
  customerAccount?: string;
  /** @format uuid */
  silo?: string;
  bookingEntity?: string;
  /** @format date */
  paymentDate?: string;
  /** @format date */
  valueDate?: string;
  instructionState?: InstructionState;
  operationCode?: OperationCode;
  scaMethod?: ScaMethod;
  riskAssessmentState?: ComplianceCheckState;
  processingState?: ProcessingState;
  feeCurrency?: string;
  feeAmount?: number;
  remittanceInformation?: string;
  paymentReason?: string;
  purposeCode?: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
}

/** Delivery instruction with resolved payment */
export interface ResolvedDeliveryInstruction {
  /** Purpose code */
  purposeCode?: string;
  /**
   * Beneficiary UUID
   * @format uuid
   */
  beneficiary?: string;
  operationCode?: OperationCode;
  chargeCode?: ChargeBearer;
  /** Payment reason */
  paymentReason?: string;
  /** Remittance information */
  remittanceInformation?: string;
  /** Fee amount */
  feeAmount?: number;
  /** Fee currency code */
  feeCurrency?: string;
  /**
   * Payment correlation ID
   * @format uuid
   */
  paymentCorrelationId?: string;
  /** Payment with resolved beneficiary object */
  payment?: ResolvedPayment;
}

/** Shared fields for swap instruction variants */
export interface SwapInstructionBase {
  /** Pay currency code */
  payCurrency?: string;
  /** Pay amount */
  payAmount?: number;
  /** Receive currency code */
  receiveCurrency?: string;
  /** Receive amount */
  receiveAmount?: number;
  quote?: QuoteAmountType;
  tenor?: TenorType;
  /** Comment */
  comment?: string;
  /**
   * Value date
   * @format date
   */
  valueDate?: string;
  /** Delivery instruction with resolved payment */
  deliveryInstruction?: ResolvedDeliveryInstruction;
}

/** Swap instruction for pricing request creation or update */
export type PricingSwapInstruction = SwapInstructionBase & {
  /** Margin currency code */
  marginCurrency: string;
  /** Margin amount */
  marginAmount?: number;
  /**
   * Transaction UUID
   * @format uuid
   */
  transaction?: string;
};

/** Request body for creating a new pricing/trade request with swap instructions. The originator is derived server-side from the authenticated user, and the silo from the customer account. */
export interface CreatePricingEngineRequest {
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount: string;
  /**
   * UUID of a customer subaccount
   * The system wide UUID of a customer subaccount.
   * @format uuid
   */
  customerSubaccount?: string;
  /**
   * Deprecated and ignored. The BFF derives the originator from the authenticated user's token and never reads this field. The web still sends the signed-in user's id here so that a web release deployed ahead of this BFF keeps quoting against a BFF that still forwards the body's originator; the web stops sending it once this BFF is deployed.
   * @deprecated
   * @format uuid
   */
  originator?: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
  /** Swap instructions */
  instructions: PricingSwapInstruction[];
}

/** Shared fields for pricing engine request variants */
export interface PricingEngineRequestBase {
  /**
   * Pricing request UUID
   * @format uuid
   */
  id: string;
  /** Resource type */
  resourceType?: string;
  state: PricingQuoteState;
  indicativeStateReason?: PricingAlert;
  /** Time to live */
  timeToLive?: number;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount: string;
  /**
   * UUID of a customer subaccount
   * The system wide UUID of a customer subaccount.
   * @format uuid
   */
  customerSubaccount?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  originator: string;
  /**
   * UUID of an ABAC Silo
   * The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC),
   * @format uuid
   */
  silo: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
}

/** Swap instruction with internal fields stripped and resolved references */
export type FilteredSwapInstruction = SwapInstructionBase & {
  /** Pay fee */
  payFee?: number;
  /** Receive fee */
  receiveFee?: number;
  /** Instruction state */
  state?: string;
  /** Indicative state reason */
  indicativeStateReason?: string;
  /** Settlement time */
  settlementTime?: string;
  /** Resolved transaction object or transaction UUID string */
  transaction?:
    | {
        /** @format uuid */
        id?: string;
        resourceType?: string;
        state?: string;
      }
    | string;
};

export type FilteredPricingEngineRequest = PricingEngineRequestBase & {
  /** Filtered swap instructions */
  instructions: FilteredSwapInstruction[];
};

/** Request body for requoting a pricing request with updated swap instructions. The originator is derived server-side from the authenticated user. */
export interface RequotePricingRequest {
  /** Updated swap instructions. Each update replaces the stored instruction at the same position. In an update's deliveryInstruction, an omitted or null field keeps the stored value and a field sent as an empty string is left out of the instruction sent to the pricing engine; a changed beneficiary starts from an empty delivery instruction. Only beneficiary, operationCode, chargeCode, remittanceInformation, paymentReason and purposeCode are sent: feeAmount, feeCurrency, paymentCorrelationId, relatedPayment and payment are never read from the client and never echoed from the stored instruction, so the pricing engine prices each requote's fees afresh. Leaving a field out clears it only if the pricing engine replaces a requote's delivery instruction rather than merging it; replace semantics are the design basis. On 2026-10-05 the owner reported requotes working on uat with this merge; a cleared field and a re-priced fee were not tested directly. */
  updates: PricingSwapInstruction[];
}

/** Bank account trimmed to fields displayed in ledger UI */
export interface FilteredBeneficiaryBankAccount {
  accountName?: string;
  accountNumber?: string;
  nationalClearingCode?: string;
  iban?: string;
  bic?: string;
  country?: string;
}

/** Fiat beneficiary trimmed to fields displayed in UI */
export interface FilteredFiatBeneficiary {
  name?: string;
  nickname?: string;
  beneficiaryType?: LegalEntityType;
  resourceType?: string;
  /** Bank account trimmed to fields displayed in ledger UI */
  bankAccount?: FilteredBeneficiaryBankAccount;
}

/** Fiat payment trimmed to fields displayed in payment list and detail views */
export interface FilteredPaymentForList {
  /** @format uuid */
  id: string;
  resourceType: string;
  reference: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta: ResourceMetadata;
  currency: string;
  amount: number;
  /** Fiat beneficiary trimmed to fields displayed in UI */
  beneficiary: FilteredFiatBeneficiary;
  /** @format date */
  paymentDate: string;
  /** @format date */
  valueDate?: string;
  paymentState: PaymentWithdrawalState;
  instructionState: InstructionState;
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  remittanceInformation?: string;
  /** Free-form reason/description for the payment (e.g., "Q3 invoice settlement"). */
  paymentReason?: string;
  /** Coded purpose classification (e.g., "goods_sold"). Translated via PaymentReason dictionary on the frontend. */
  purposeCode?: string;
  feeAmount?: number;
  feeCurrency?: string;
}

/** Legal entity trimmed to display-name fields only */
export interface FilteredLegalEntity {
  type?: LegalEntityType;
  firstName?: string;
  lastName?: string;
  companyName?: string;
}

/** Virtual asset trimmed to ledgerProduct only (for currency display) */
export interface FilteredVirtualAssetForPayment {
  ledgerProduct?: string;
}

/** Blockchain beneficiary trimmed to fields displayed in payment list and detail views */
export interface FilteredBlockchainBeneficiaryForPayment {
  /** Legal entity trimmed to display-name fields only */
  legalEntity?: FilteredLegalEntity;
  nickname?: string;
  resourceType?: string;
  /** Blockchain wallet trimmed to address and network info */
  wallet?: FilteredBlockchainWallet;
  /** Virtual asset trimmed to ledgerProduct only (for currency display) */
  asset?: FilteredVirtualAssetForPayment;
}

/** Withdrawal fee with amount and product */
export interface FilteredBlockchainWithdrawalFee {
  amount?: number;
  product?: string;
}

/** Blockchain withdrawal trimmed to fields displayed in payment list and detail views */
export interface FilteredBlockchainWithdrawalForList {
  /** @format uuid */
  id: string;
  resourceType: string;
  reference: string;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta: ResourceMetadata;
  amount: number;
  /** Blockchain beneficiary trimmed to fields displayed in payment list and detail views */
  beneficiary: FilteredBlockchainBeneficiaryForPayment;
  /** @format date */
  withdrawalDate: string;
  /** @format date */
  valueDate?: string;
  withdrawalState: PaymentWithdrawalState;
  instructionState: InstructionState;
  scaMethod?: ScaMethod;
  processingState?: ProcessingState;
  /** Withdrawal fee with amount and product */
  fee?: FilteredBlockchainWithdrawalFee;
}

export interface BeneficiaryTemplateField {
  attribute?: string;
  description?: string;
  label?: string;
  regex?: string;
  required?: boolean;
}

export interface BeneficiaryTemplate {
  id?: string;
  resourceType?: string;
  currency?: string;
  country?: string;
  beneficiaryType?: LegalEntityType;
  defaultOperationCode?: OperationCode;
  addressRequired?: NotRequiredOptionalRequired;
  name?: string;
  description?: string;
  fields?: BeneficiaryTemplateField[];
  paymentSystems?: string[];
  operationCodes?: string[];
}

export interface BeneficiaryTemplatePage {
  data?: BeneficiaryTemplate[];
}

/** Virtual asset trimmed to id, ledgerProduct, and blockchain.id */
export interface FilteredVirtualAsset {
  /** @format uuid */
  id?: string;
  ledgerProduct?: string;
  blockchain?: {
    id?: string;
  };
}

/** Page of filtered virtual assets */
export interface FilteredVirtualAssetPage {
  data?: FilteredVirtualAsset[];
  /** Metadata for a page of resources. This supports cursor based pagination suitable for navigating a growing or streaming data collection via the  'startCursor' and 'endCursor'  properties. Search endpoints that wish to offer  cursor based pagination queries need to accept 'page[cursor]' and 'page[size]'  query parameters. Clients querying such an endpoint can then include one of the cursors together with a page size to request the previous or next page */
  meta?: PageMetadata;
}

/** Metadata for a page of resources. This supports cursor based pagination suitable for navigating a growing or streaming data collection via the  'startCursor' and 'endCursor'  properties. Search endpoints that wish to offer  cursor based pagination queries need to accept 'page[cursor]' and 'page[size]'  query parameters. Clients querying such an endpoint can then include one of the cursors together with a page size to request the previous or next page */
export interface PageMetadata {
  /** Pagination support. Presence indicates that there are items falling above this cursor in the data collection. This property can be used as the 'page[cursor]' parameter in subsequent searches with a negative 'page[size]' query parameter to  obtain the previous page. */
  startCursor?: string;
  /** Pagination support. Presence indicates that there are items falling below this cursor in the data collection. This property can be used as the 'page[cursor]' parameter in subsequent searches with a positive 'page[size]' query parameter to  obtain the next page. */
  endCursor?: string;
}

/** Page of filtered VASPs with only id and name */
export interface FilteredVaspInfoPage {
  data?: FilteredVaspInfo[];
  /** Metadata for a page of resources. This supports cursor based pagination suitable for navigating a growing or streaming data collection via the  'startCursor' and 'endCursor'  properties. Search endpoints that wish to offer  cursor based pagination queries need to accept 'page[cursor]' and 'page[size]'  query parameters. Clients querying such an endpoint can then include one of the cursors together with a page size to request the previous or next page */
  meta?: PageMetadata;
}

/** Blockchain explorer trimmed to frontend-used fields */
export interface FilteredBlockchainExplorer {
  addressUrl?: string;
  transactionUrl?: string;
}

/** Blockchain network trimmed to display fields with address-only explorer */
export interface FilteredBlockchainNetwork {
  id?: string;
  name?: string;
  /** Blockchain explorer trimmed to frontend-used fields */
  explorer?: FilteredBlockchainExplorer;
}

/** Blockchain wallet trimmed to address and network info */
export interface FilteredBlockchainWallet {
  address?: string;
  /** Blockchain network trimmed to display fields with address-only explorer */
  blockchain?: FilteredBlockchainNetwork;
}

/** VASP trimmed to id and name only */
export interface FilteredVaspInfo {
  /** @format uuid */
  id?: string;
  name?: string;
}

/** Legal entity trimmed to fields used by beneficiary detail view */
export interface FilteredResolvedBlockchainBeneficiaryLegalEntity {
  type: LegalEntityType;
  /** ISO 3166-1 Alpha-2 country code */
  country: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  townName: string;
  countrySubDivision?: string;
  postCode?: string;
  addressLine?: string[];
}

/** Blockchain beneficiary trimmed to fields used by beneficiary detail view */
export interface FilteredResolvedBlockchainBeneficiary {
  /** @format uuid */
  id?: string;
  resourceType?: string;
  nickname?: string;
  trusted?: boolean;
  whitelisted?: boolean;
  walletType?: WalletType;
  /** Blockchain wallet trimmed to address and network info */
  wallet?: FilteredBlockchainWallet;
  asset?: {
    ledgerProduct?: string;
  };
  /** VASP trimmed to id and name only */
  vasp?: FilteredVaspInfo;
  /** Legal entity trimmed to fields used by beneficiary detail view */
  legalEntity?: FilteredResolvedBlockchainBeneficiaryLegalEntity;
}

export interface SendEmailOtpRequest {
  /** @format email */
  email: string;
  captchaToken: string;
}

export interface VerifyEmailOtpRequest {
  /** @format email */
  email: string;
  code: string;
}

export interface SendSmsOtpRequest {
  mobilePhone: MobilePhone;
  emailVerificationToken?: string;
}

export interface SendOtpResponse {
  message?: string;
  /** @format int32 */
  expiresIn?: number;
}

export interface VerifySmsOtpRequest {
  mobilePhone: MobilePhone;
  code: string;
}

export interface VerifyOtpResponse {
  verificationToken?: string;
}

export interface MobilePhone {
  /** National phone number (without international prefix) */
  number: string;
  /**
   * ISO 3166-1 alpha-2 country code (e.g. GB)
   * @minLength 2
   * @maxLength 2
   */
  country: string;
}

export interface RegisterRequest {
  firstName: string;
  lastName: string;
  /** @format email */
  email: string;
  mobilePhone: MobilePhone;
  password: string;
  /** OAuth2 client ID for token issuance */
  clientId: string;
  emailVerificationToken: string;
  phoneVerificationToken: string;
}

export interface RegisterResponse {
  refreshToken?: string;
}

export interface PhonePrefix {
  /** ISO 3166-1 alpha-2 country code */
  country?: string;
  /** International dialling prefix with leading + */
  phonePrefix?: string;
}

export interface Registration {
  /** @format uuid */
  id: string;
  /** @format email */
  email: string;
  /** E.164 formatted phone number */
  mobilePhone: string;
  kycStatus?: RequiredCompletedVerifiedRejected;
}

export interface RegistrationPage {
  data?: Registration[];
}

export interface KycAccessTokenResponse {
  /** Short-lived SumSub WebSDK access token (~10 min TTL) */
  token: string;
  /** Whether the caller still needs identity verification. When false, the frontend should skip the SumSub widget. */
  requiresVerification: boolean;
}

export interface CustomerAccountApplicationPage {
  data?: CustomerAccountApplication[];
}

export interface CreateCustomerAccountApplicationRequest {
  applicationType: ApplicationType;
  requiresDigitalAssets?: boolean;
  /**
   * @minLength 1
   * @maxLength 256
   */
  silo?: string;
}

export interface CustomerAccountApplication {
  /** @format uuid */
  id?: string;
  applicationType?: ApplicationType;
  applicationState?: ApplicationState;
  requiresDigitalAssets?: boolean;
  /**
   * @minLength 1
   * @maxLength 256
   */
  silo?: string;
  formData?: ApplicationFormData;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface PersonalDetails {
  title?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  /** @format date */
  dateOfBirth: string;
  /** ISO 3166-1 Alpha-2 country code */
  countryOfBirth?: string;
  nationalities?: string[];
  address: Address;
  occupation?: string;
}

export interface AccountPurposeSelection {
  selected: AccountPurpose[];
  /** Freeform explanation, typically provided when OTHER is selected. */
  comment?: string;
}

export interface AccountUseFormData {
  baseCurrency: string;
  accountPurpose: AccountPurposeSelection;
  monthlyTurnover: number;
  requiresDigitalAssets?: boolean;
  flowOfFunds?: string;
}

export interface SourceOfFundsSelection {
  selected: SourceOfFunds[];
  /** Freeform explanation, typically provided when OTHER is selected. */
  comment?: string;
}

export interface IncomingPayments {
  sourceOfFunds?: SourceOfFundsSelection;
  fromThirdParties: boolean;
  expectedCreditsPerMonth: number;
  /** Largest single incoming transaction value in base currency */
  maxCreditValue: number;
  sourceCountries?: string[];
  sourceCurrencies?: string[];
}

export interface OutgoingPayments {
  expectedDebitsPerMonth: number;
  /** Largest single outgoing transaction value in base currency */
  maxDebitValue: number;
  toThirdParties: boolean;
  destinationCountries?: string[];
  destinationCurrencies?: string[];
}

export interface Consents {
  termsAccepted: boolean;
  privacyAccepted: boolean;
  marketingOptIn: boolean;
  /** Whether the applicant acknowledged that they approached the firm on their own initiative (reverse solicitation). Required for applicants not based/incorporated in GB; sent as false for GB-based applicants. */
  reverseSolicitationAcknowledged: boolean;
}

export interface BusinessTypeSelection {
  selected?: BusinessType;
  /** Freeform explanation, typically provided when selected is OTHER. */
  comment?: string;
}

export interface UserRelationshipSelection {
  selected: PrimaryContactRelationship;
  /** Freeform explanation, typically provided when selected is OTHER. */
  comment?: string;
}

export interface PrimaryContactDetails {
  title?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  /** @format date */
  dateOfBirth: string;
  /** ISO 3166-1 Alpha-2 country code */
  nationality: string;
  /** @format email */
  email?: string;
  mobilePhone?: MobilePhone;
  /** Address */
  address?: {
    udprn?: number;
    /** Summary line for non-structured addresses */
    line1?: string;
    line2?: string;
    line3?: string;
    buildingName?: string;
    /** When a premise is split into individual units such as flats, apartments or business units */
    buildingName2?: string;
    /** Number to identify premise on a thoroughfare */
    buildingNumber?: string;
    /** Street name */
    thoroughfare?: string;
    /** Secondary street name */
    thoroughfare2?: string;
    locality?: string;
    locality2?: string;
    postBox?: string;
    postTown?: string;
    /** Postcode in country print format */
    postCode?: string;
    organisation?: string;
    /** Department within the organisation */
    department?: string;
    /** Used for addresses in federal countries (US, MX, CA, etc) */
    state?: string;
    /** ISO 3166-1 Alpha-2 country code */
    country?: string;
    longitude?: number;
    latitude?: number;
  };
}

export interface PrimaryContact {
  isApplicant?: boolean;
  relationship?: UserRelationshipSelection;
  contactDetails?: PrimaryContactDetails;
}

export interface BusinessDetailsFormData {
  businessType?: BusinessTypeSelection;
  companyName: string;
  companyNumber: string;
  countryOfIncorporation: string;
  industrySector?: string;
  companyWebsite?: string;
  /** Business description including products/services, operational model, geographic footprint. Third-party payment explanations appended with prefix keys [THIRD_PARTY_INCOMING] and [THIRD_PARTY_OUTGOING]. */
  businessDescription?: string;
  /** Reported annual revenue in base currency — the last financial year's figure, or a forecast for newly incorporated companies. */
  annualRevenue?: number;
  /** BusinessAddresses */
  addresses?: Record<
    string,
    {
      udprn?: number;
      /** Summary line for non-structured addresses */
      line1?: string;
      line2?: string;
      line3?: string;
      buildingName?: string;
      /** When a premise is split into individual units such as flats, apartments or business units */
      buildingName2?: string;
      /** Number to identify premise on a thoroughfare */
      buildingNumber?: string;
      /** Street name */
      thoroughfare?: string;
      /** Secondary street name */
      thoroughfare2?: string;
      locality?: string;
      locality2?: string;
      postBox?: string;
      postTown?: string;
      /** Postcode in country print format */
      postCode?: string;
      organisation?: string;
      /** Department within the organisation */
      department?: string;
      /** Used for addresses in federal countries (US, MX, CA, etc) */
      state?: string;
      /** ISO 3166-1 Alpha-2 country code */
      country?: string;
      longitude?: number;
      latitude?: number;
    }
  >;
  primaryContact?: PrimaryContact;
}

export interface ApplicationFormData {
  personalDetails?: PersonalDetails;
  accountUse?: AccountUseFormData;
  incomingPayments?: IncomingPayments;
  outgoingPayments?: OutgoingPayments;
  consents?: Consents;
  businessDetails?: BusinessDetailsFormData;
}

export interface UpdateCustomerAccountApplicationRequest {
  formData?: ApplicationFormData;
}

export interface TransactionRanges {
  currency?: string;
  /** Upper-bound values for monthly turnover (e.g., [100000, 250000, 500000, 1000000, 5000000]) */
  monthlyTurnoverOptions?: number[];
  /** Upper-bound values for single transaction (e.g., [10000, 50000, 100000, 250000, 500000]) */
  singleTransactionOptions?: number[];
  /** Upper-bound values for expected transaction count (e.g., [10, 50, 100, 500, 1000]) */
  creditsPerMonthOptions?: number[];
  /** Upper-bound values for expected debit count (e.g., [10, 50, 100, 500, 1000]) */
  debitsPerMonthOptions?: number[];
}

/** Business type with internal fields removed (prohibited entries excluded) */
export interface FilteredBusinessType {
  id: string;
  name: string;
  sector: string;
}

export interface FilteredBusinessTypePage {
  data: FilteredBusinessType[];
}

export interface GetSettlementMethodsParams {
  /**
   * UUID of the customer account
   * @format uuid
   */
  customerAccountId: string;
}

export type GetSettlementMethodsData = SettlementMethodsResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetSettlementMethodsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetCustomerAccountBalancesParams {
  /**
   * UUID of the customer account
   * @format uuid
   */
  customerAccountId: string;
}

export type GetCustomerAccountBalancesData = BalancesResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetCustomerAccountBalancesError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetCustomerAccountCapabilitiesParams {
  /**
   * UUID of the customer account
   * @format uuid
   */
  customerAccountId: string;
}

export type GetCustomerAccountCapabilitiesData = CapabilitiesResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetCustomerAccountCapabilitiesError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetDeliverableCountriesParams {
  /**
   * UUID of the customer account
   * @format uuid
   */
  customerAccountId: string;
  /** Currency code (e.g., GBP, EUR, USD) - reserved for future filtering */
  currency: string;
}

export type GetDeliverableCountriesData = DeliverableCountriesResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetDeliverableCountriesError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetCustomerAccountBeneficialOwnersParams {
  /**
   * UUID of the customer account
   * @format uuid
   */
  customerAccountId: string;
}

export type GetCustomerAccountBeneficialOwnersData = BeneficialOwnersResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetCustomerAccountBeneficialOwnersError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetCountriesParams {
  /** Sort countries by ID or NAME */
  sortBy?: CountrySortBy;
}

export type GetCountriesData = CountriesResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetCountriesError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export type GetSelfData = Self;

export type GetSelfError = ExceptionDetail;

export type GetProductsData = ProductPage;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetProductsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetCustomerAccountStatementParams {
  /** A query parameter indicating a frame of reference for dates */
  timeFrame: TimeFrame;
  /**
   * ISO 8601 date (in yyyy-mm-dd format) representing the start of a local date range. This query parameter will be paired with an EndDate parameter.
   * @format date
   */
  startDate: string;
  /**
   * ISO 8601 date (in yyyy-mm-dd format) representing the end of a local date range. This query parameter will be paired with an StartDate parameter.
   * @format date
   */
  endDate: string;
  /**
   * Ledger Account Code
   * Code of a `ledger-account` entity managed by the `@jftechnology/ledger` service.
   * @format int32
   * @min 1
   */
  ledgerCode: number;
  /** Filter by journal(s) */
  "filter[journal]"?: string[];
  /**
   * UUID of the customer account
   * @format uuid
   */
  customerAccountId: string;
  /** Product identifier */
  productId: string;
}

export type GetCustomerAccountStatementData = ResolvedStatement;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetCustomerAccountStatementError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetLedgerEntriesParams {
  /** A query parameter indicating a frame of reference for dates */
  timeFrame: TimeFrame;
  /**
   * Start date filter
   * @format date
   */
  startDate?: string;
  /**
   * End date filter
   * @format date
   */
  endDate?: string;
  /** Filter by product codes */
  filterProduct?: string[];
  /** Filter by bank account UUIDs */
  filterBankAccount?: string[];
  /** Filter by customer account UUIDs */
  filterCustomerAccount?: string[];
  /** Filter by silo UUIDs */
  filterSilo?: string[];
  /** Filter by ledger codes */
  filterLedgerCode?: number[];
  /** Filter by ledger types */
  filterLedgerType?: string[];
  /** Filter by booking entity codes */
  filterBookingEntity?: string[];
  /** Cursor for page-based navigation. Use endCursor from PageMetadata to get the next page. */
  pageCursor?: string;
  /**
   * Number of items per page (1–300, default 200).
   * @min 1
   * @max 300
   * @default 200
   */
  pageSize?: number;
}

export type GetLedgerEntriesData = ResolvedLedgerEntryPage;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetLedgerEntriesError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface CreateOtopParams {
  /** Type of resource requiring OTOP verification */
  resourceType: OtopRequestResourceType;
  /**
   * UUID of the resource requiring OTOP verification
   * @format uuid
   */
  resourceTypeId: string;
}

/** OtopRequest.response */
export interface CreateOtopData {
  /**
   * Unique id for the OTOP request
   * @format uuid
   */
  id: string;
  state: OtopRequestState;
  /**
   * Number of failed verification attempts
   * @format int32
   */
  failures: number;
  /**
   * Time indicating when OTOP will expire
   * @format date-time
   */
  expiryTime: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type CreateOtopError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface VerifyOtopParams {
  /**
   * UUID of the OTOP request to verify
   * @format uuid
   */
  otopRequestId: string;
}

export type VerifyOtopData = OtopRequestResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type VerifyOtopError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export type DoCopCheckData = CopCheckResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type DoCopCheckError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetPaymentRequirementsParams {
  /** @format uuid */
  uuid: string;
}

export type GetPaymentRequirementsData = ConfirmationRequirement;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetPaymentRequirementsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetBlockchainWithdrawalRequirementsParams {
  /** @format uuid */
  uuid: string;
}

/** ConfirmationRequirement */
export interface GetBlockchainWithdrawalRequirementsData {
  /**
   * Unique identifier for the resource
   * @format uuid
   */
  id: string;
  /** Type of resource requiring confirmation */
  resourceType: string;
  /** Whether Strong Customer Authentication is required */
  scaRequired: boolean;
  /**
   * Number of confirmers required
   * @format int32
   * @min 0
   */
  confirmersRequired: number;
  /** Array of confirmer objects for users who have already confirmed */
  currentConfirmers: {
    /**
     * Unique identifier of the person who can confirm
     * @format uuid
     */
    id: string;
    /** First name of the confirmer */
    firstName: string;
    /** Last name of the confirmer */
    lastName: string;
  }[];
  /** Array of confirmer objects for users who are available to confirm */
  availableConfirmers: Confirmer[];
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetBlockchainWithdrawalRequirementsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface ConfirmPaymentInstructionParams {
  /**
   * UUID of the payment to confirm
   * @format uuid
   */
  paymentId: string;
}

/**
 * Payment.stripped.page
 * Paginated list of payments with internal fields stripped.
 */
export interface ConfirmPaymentInstructionData {
  data: {
    /** @format uuid */
    id: string;
    resourceType: string;
    reference: string;
    /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
    meta: ResourceMetadata;
    /** Unique key of this transaction in the downstream source */
    correlationId?: string;
    paymentState: PaymentWithdrawalState;
    /**
     * Currency symbol
     * Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
     * @pattern ^[A-Z]{3}$
     */
    currency: string;
    amount: number;
    /**
     * UUID of the beneficiary
     * @format uuid
     */
    beneficiary: string;
    /**
     * UUID of a customer account
     * The system wide UUID of a customer account.
     * @format uuid
     */
    customerAccount: string;
    customerReference?: string;
    /** @format date */
    paymentDate: string;
    /** @format date */
    valueDate?: string;
    /** @format date-time */
    acceptableUntil?: string;
    chargeCode?: ChargeBearer;
    operationCode?: OperationCode;
    remittanceInformation?: string;
    paymentReason?: string;
    purposeCode?: string;
    ultimateBeneficiary?: string;
    /**
     * Currency symbol
     * Id of a product of type `currencies` managed by the `@jftechnology/ledger` service. This is a product code narrowed to a 3 char ISO 4217 currency code
     * @pattern ^[A-Z]{3}$
     */
    feeCurrency?: string;
    feeAmount?: number;
    instructionState: InstructionState;
    /**
     * UUID of a person
     * The system wide UUID of a person.
     * @format uuid
     */
    instructionOriginator?: string;
    /**
     * UUID of a person
     * The system wide UUID of a person.
     * @format uuid
     */
    instructionPlacer?: string;
    instructionConfirmers?: string[];
    scaMethod?: ScaMethod;
    processingState?: ProcessingState;
    /**
     * Correlation UUID for the processing operation
     * @format uuid
     */
    processingId?: string;
    /** @format uuid */
    processedBankTransaction?: string;
    comment?: string;
  }[];
  /** Metadata for a page of resources. This supports cursor based pagination suitable for navigating a growing or streaming data collection via the  'startCursor' and 'endCursor'  properties. Search endpoints that wish to offer  cursor based pagination queries need to accept 'page[cursor]' and 'page[size]'  query parameters. Clients querying such an endpoint can then include one of the cursors together with a page size to request the previous or next page */
  meta?: PageMetadata;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type ConfirmPaymentInstructionError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface CancelPaymentInstructionParams {
  /**
   * UUID of the payment to cancel
   * @format uuid
   */
  paymentId: string;
}

export type CancelPaymentInstructionData = PaymentStrippedPage;

/**
 * ExceptionDetail
 * Contains error message
 */
export type CancelPaymentInstructionError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface ConfirmBlockchainWithdrawalInstructionParams {
  /**
   * UUID of the blockchain withdrawal to confirm
   * @format uuid
   */
  blockchainWithdrawalId: string;
}

/** BlockchainWithdrawal.stripped */
export interface ConfirmBlockchainWithdrawalInstructionData {
  /**
   * Journal UUID of a blockchain withdrawal
   * @format uuid
   */
  id: string;
  resourceType: string;
  reference: string;
  /**
   * ResourceMetadata
   * Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state.
   */
  meta: {
    /**
     * Time and date this resource was created.
     * @format date-time
     */
    createTime?: string;
    /**
     * UUID of a person
     * The system wide UUID of a person.
     * @format uuid
     */
    createUser?: string;
    /**
     * Time and date this resource was last updated.
     * @format date-time
     */
    updateTime?: string;
    /**
     * UUID of a person
     * The system wide UUID of a person.
     * @format uuid
     */
    updateUser?: string;
    /** Describes reason for the update. */
    updateComment?: string;
    /**
     * Zero based count of updates.
     * @format int32
     * @min 0
     */
    version?: number;
    state?: ActiveInactiveDeleted;
  };
  withdrawalState: PaymentWithdrawalState;
  /**
   * UUID of a withdrawal beneficiary entity
   * @format uuid
   */
  beneficiary: string;
  amount: number;
  customerReference?: string;
  /** @format date */
  withdrawalDate: string;
  /** @format date */
  valueDate?: string;
  /** @format date-time */
  acceptableUntil?: string;
  fee?: {
    product?: string;
    amount?: number;
  };
  instructionState: InstructionState;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  instructionOriginator?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  instructionPlacer?: string;
  instructionConfirmers?: string[];
  scaMethod?: ScaMethod;
  /** @format uuid */
  processingId?: string;
  comment?: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type ConfirmBlockchainWithdrawalInstructionError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface CancelBlockchainWithdrawalInstructionParams {
  /**
   * UUID of the blockchain withdrawal to cancel
   * @format uuid
   */
  blockchainWithdrawalId: string;
}

export type CancelBlockchainWithdrawalInstructionData =
  BlockchainWithdrawalStripped;

/**
 * ExceptionDetail
 * Contains error message
 */
export type CancelBlockchainWithdrawalInstructionError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetPaymentReasonsParams {
  /** Currency code (e.g., GBP, USD) - reserved for future use */
  currency: string;
  /** Country code (e.g., GB, US) - reserved for future use */
  country: string;
}

export type GetPaymentReasonsData = PaymentReason[];

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetPaymentReasonsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetPricesParams {
  /** Base product symbol (e.g., GBP, USD, EUR) */
  baseProduct: string;
}

export type GetPricesData = FilteredTickerPricePage;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetPricesError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export type CreateBeneficiaryData = IdOnlyResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type CreateBeneficiaryError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetBeneficiaryParams {
  /** @format uuid */
  uuid: string;
}

export type GetBeneficiaryData = FilteredBeneficiaryDetail;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetBeneficiaryError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface UpdateBeneficiaryParams {
  /** @format uuid */
  uuid: string;
}

/**
 * IdOnlyResponse
 * Minimal mutation response containing only the resource identifier. Used for fire-and-forget mutations where the client relies on cache invalidation rather than the response body.
 */
export interface UpdateBeneficiaryData {
  /** @format uuid */
  id: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type UpdateBeneficiaryError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface DeleteBeneficiaryParams {
  /** @format uuid */
  uuid: string;
}

/**
 * IdOnlyResponse
 * Minimal mutation response containing only the resource identifier. Used for fire-and-forget mutations where the client relies on cache invalidation rather than the response body.
 */
export interface DeleteBeneficiaryData {
  /** @format uuid */
  id: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type DeleteBeneficiaryError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export type CreatePricingRequestData = FilteredPricingEngineRequest;

/**
 * ExceptionDetail
 * Contains error message
 */
export type CreatePricingRequestError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetPricingRequestParams {
  /** @format uuid */
  uuid: string;
}

/**
 * FilteredPricingEngineRequest
 * Shared fields for pricing engine request variants
 */
export type GetPricingRequestData = {
  /**
   * Pricing request UUID
   * @format uuid
   */
  id: string;
  /** Resource type */
  resourceType?: string;
  state: PricingQuoteState;
  indicativeStateReason?: PricingAlert;
  /** Time to live */
  timeToLive?: number;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount: string;
  /**
   * UUID of a customer subaccount
   * The system wide UUID of a customer subaccount.
   * @format uuid
   */
  customerSubaccount?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  originator: string;
  /**
   * UUID of an ABAC Silo
   * The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC),
   * @format uuid
   */
  silo: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
} & {
  /** Filtered swap instructions */
  instructions: (SwapInstructionBase & {
    /** Pay fee */
    payFee?: number;
    /** Receive fee */
    receiveFee?: number;
    /** Instruction state */
    state?: string;
    /** Indicative state reason */
    indicativeStateReason?: string;
    /** Settlement time */
    settlementTime?: string;
    /** Resolved transaction object or transaction UUID string */
    transaction?:
      | {
          /** @format uuid */
          id?: string;
          resourceType?: string;
          state?: string;
        }
      | string;
  })[];
};

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetPricingRequestError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface RequotePricingRequestParams {
  /** @format uuid */
  uuid: string;
}

/**
 * FilteredPricingEngineRequest
 * Shared fields for pricing engine request variants
 */
export type RequotePricingRequestData = {
  /**
   * Pricing request UUID
   * @format uuid
   */
  id: string;
  /** Resource type */
  resourceType?: string;
  state: PricingQuoteState;
  indicativeStateReason?: PricingAlert;
  /** Time to live */
  timeToLive?: number;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount: string;
  /**
   * UUID of a customer subaccount
   * The system wide UUID of a customer subaccount.
   * @format uuid
   */
  customerSubaccount?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  originator: string;
  /**
   * UUID of an ABAC Silo
   * The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC),
   * @format uuid
   */
  silo: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
} & {
  /** Filtered swap instructions */
  instructions: (SwapInstructionBase & {
    /** Pay fee */
    payFee?: number;
    /** Receive fee */
    receiveFee?: number;
    /** Instruction state */
    state?: string;
    /** Indicative state reason */
    indicativeStateReason?: string;
    /** Settlement time */
    settlementTime?: string;
    /** Resolved transaction object or transaction UUID string */
    transaction?:
      | {
          /** @format uuid */
          id?: string;
          resourceType?: string;
          state?: string;
        }
      | string;
  })[];
};

/**
 * ExceptionDetail
 * Contains error message
 */
export type RequotePricingRequestError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface AcceptPricingRequestParams {
  /** @format uuid */
  uuid: string;
}

/**
 * FilteredPricingEngineRequest
 * Shared fields for pricing engine request variants
 */
export type AcceptPricingRequestData = {
  /**
   * Pricing request UUID
   * @format uuid
   */
  id: string;
  /** Resource type */
  resourceType?: string;
  state: PricingQuoteState;
  indicativeStateReason?: PricingAlert;
  /** Time to live */
  timeToLive?: number;
  /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
  meta?: ResourceMetadata;
  /**
   * UUID of a customer account
   * The system wide UUID of a customer account.
   * @format uuid
   */
  customerAccount: string;
  /**
   * UUID of a customer subaccount
   * The system wide UUID of a customer subaccount.
   * @format uuid
   */
  customerSubaccount?: string;
  /**
   * UUID of a person
   * The system wide UUID of a person.
   * @format uuid
   */
  originator: string;
  /**
   * UUID of an ABAC Silo
   * The system wide UUID of a silo. Silos form the basis of Access Based Access Control (ABAC),
   * @format uuid
   */
  silo: string;
  /** Booking entity code */
  bookingEntity?: string;
  /** Comment */
  comment?: string;
} & {
  /** Filtered swap instructions */
  instructions: (SwapInstructionBase & {
    /** Pay fee */
    payFee?: number;
    /** Receive fee */
    receiveFee?: number;
    /** Instruction state */
    state?: string;
    /** Indicative state reason */
    indicativeStateReason?: string;
    /** Settlement time */
    settlementTime?: string;
    /** Resolved transaction object or transaction UUID string */
    transaction?:
      | {
          /** @format uuid */
          id?: string;
          resourceType?: string;
          state?: string;
        }
      | string;
  })[];
};

/**
 * ExceptionDetail
 * Contains error message
 */
export type AcceptPricingRequestError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetAllBeneficiariesParams {
  /** Filter by beneficiary name */
  filterName?: string;
  /** Filter by customer account UUIDs */
  filterCustomerAccount?: string[];
  /** Filter by active status */
  filterActive?: boolean;
  /** Cursor for page-based navigation. Use endCursor from PageMetadata to get the next page. */
  pageCursor?: string;
  /**
   * Number of items per page (1–300, default 200).
   * @min 1
   * @max 300
   * @default 200
   */
  pageSize?: number;
}

export type GetAllBeneficiariesData = {
  /** @format uuid */
  id?: string;
  /** Either 'beneficiaries' or 'blockchain-beneficiaries' */
  resourceType?: string;
  nickname?: string;
}[];

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetAllBeneficiariesError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetUnconfirmedPaymentsParams {
  /** Filter by customer account UUIDs */
  filterCustomerAccount?: string[];
  /** Filter by currency codes (e.g. GBP, EUR, BTC) */
  filterCurrency?: string[];
}

/** Combined unconfirmed/processing payments and blockchain withdrawals */
export interface GetUnconfirmedPaymentsData {
  payments?: {
    /** @format uuid */
    id: string;
    resourceType: string;
    reference: string;
    /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
    meta: ResourceMetadata;
    currency: string;
    amount: number;
    /**
     * FilteredFiatBeneficiary
     * Fiat beneficiary trimmed to fields displayed in UI
     */
    beneficiary: {
      name?: string;
      nickname?: string;
      beneficiaryType?: LegalEntityType;
      resourceType?: string;
      /**
       * FilteredBeneficiaryBankAccount
       * Bank account trimmed to fields displayed in ledger UI
       */
      bankAccount?: {
        accountName?: string;
        accountNumber?: string;
        nationalClearingCode?: string;
        iban?: string;
        bic?: string;
        country?: string;
      };
    };
    /** @format date */
    paymentDate: string;
    /** @format date */
    valueDate?: string;
    paymentState: PaymentWithdrawalState;
    instructionState: InstructionState;
    scaMethod?: ScaMethod;
    processingState?: ProcessingState;
    remittanceInformation?: string;
    /** Free-form reason/description for the payment (e.g., "Q3 invoice settlement"). */
    paymentReason?: string;
    /** Coded purpose classification (e.g., "goods_sold"). Translated via PaymentReason dictionary on the frontend. */
    purposeCode?: string;
    feeAmount?: number;
    feeCurrency?: string;
  }[];
  withdrawals?: {
    /** @format uuid */
    id: string;
    resourceType: string;
    reference: string;
    /** Metadata for a resource. Supports the creation and updating user/timestamp pattern provided by auditable resources, and logical delete state. */
    meta: ResourceMetadata;
    amount: number;
    /**
     * FilteredBlockchainBeneficiaryForPayment
     * Blockchain beneficiary trimmed to fields displayed in payment list and detail views
     */
    beneficiary: {
      /**
       * FilteredLegalEntity
       * Legal entity trimmed to display-name fields only
       */
      legalEntity?: {
        type?: LegalEntityType;
        firstName?: string;
        lastName?: string;
        companyName?: string;
      };
      nickname?: string;
      resourceType?: string;
      /** Blockchain wallet trimmed to address and network info */
      wallet?: FilteredBlockchainWallet;
      /**
       * FilteredVirtualAssetForPayment
       * Virtual asset trimmed to ledgerProduct only (for currency display)
       */
      asset?: {
        ledgerProduct?: string;
      };
    };
    /** @format date */
    withdrawalDate: string;
    /** @format date */
    valueDate?: string;
    withdrawalState: PaymentWithdrawalState;
    instructionState: InstructionState;
    scaMethod?: ScaMethod;
    processingState?: ProcessingState;
    /**
     * FilteredBlockchainWithdrawalFee
     * Withdrawal fee with amount and product
     */
    fee?: {
      amount?: number;
      product?: string;
    };
  }[];
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetUnconfirmedPaymentsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetProcessingPaymentsParams {
  /** Filter by customer account UUIDs */
  filterCustomerAccount?: string[];
  /** Filter by currency codes (e.g. GBP, EUR, BTC) */
  filterCurrency?: string[];
}

/** Combined unconfirmed/processing payments and blockchain withdrawals */
export interface GetProcessingPaymentsData {
  payments?: FilteredPaymentForList[];
  withdrawals?: FilteredBlockchainWithdrawalForList[];
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetProcessingPaymentsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetBeneficiaryTemplatesParams {
  /** Filter by currency codes */
  filterCurrency?: string[];
  /** Filter by country codes */
  filterCountry?: string[];
  /** Filter by beneficiary type */
  filterBeneficiaryType?: string[];
}

export type GetBeneficiaryTemplatesData = BeneficiaryTemplatePage;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetBeneficiaryTemplatesError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetVirtualAssetsParams {
  /** Cursor for page-based navigation. Use endCursor from PageMetadata to get the next page. */
  pageCursor?: string;
  /**
   * Number of items per page (1–300, default 200).
   * @min 1
   * @max 300
   * @default 200
   */
  pageSize?: number;
}

export type GetVirtualAssetsData = FilteredVirtualAssetPage;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetVirtualAssetsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetVaspsParams {
  /** Cursor for page-based navigation. Use endCursor from PageMetadata to get the next page. */
  pageCursor?: string;
  /**
   * Number of items per page (1–300, default 200).
   * @min 1
   * @max 300
   * @default 200
   */
  pageSize?: number;
}

export type GetVaspsData = FilteredVaspInfoPage;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetVaspsError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

/** Request body for creating a blockchain beneficiary. Trust is granted only through the OTP trust step, and whitelisting is an operator designation, so the request carries no trusted or whitelisted flag; any field not declared here is dropped before the request reaches the journal-blockchain service. */
export interface CreateBlockchainBeneficiaryPayload {
  /** @format uuid */
  customerAccount: string;
  /** @format uuid */
  asset: string;
  address: string;
  customerReference?: string;
  nickname?: string;
  walletType?: WalletType;
  /** @format uuid */
  vasp?: string;
  vaspDetails?: string;
  /** Legal entity information for a blockchain beneficiary (person or corporation) */
  legalEntity?: {
    type: LegalEntityType;
    firstName?: string;
    lastName?: string;
    companyName?: string;
    department?: string;
    subDepartment?: string;
    streetName?: string;
    buildingNumber?: string;
    buildingName?: string;
    floor?: string;
    postBox?: string;
    room?: string;
    postCode?: string;
    townName: string;
    townLocationName?: string;
    districtName?: string;
    countrySubDivision?: string;
    addressLine?: string[];
    /** ISO 3166-1 Alpha-2 country code */
    country: string;
  };
  active?: boolean;
  comment?: string;
}

/**
 * IdOnlyResponse
 * Minimal mutation response containing only the resource identifier. Used for fire-and-forget mutations where the client relies on cache invalidation rather than the response body.
 */
export interface CreateBlockchainBeneficiaryData {
  /** @format uuid */
  id: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type CreateBlockchainBeneficiaryError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetBlockchainBeneficiaryParams {
  /** @format uuid */
  uuid: string;
}

export type GetBlockchainBeneficiaryData =
  FilteredResolvedBlockchainBeneficiary;

/**
 * ExceptionDetail
 * Contains error message
 */
export type GetBlockchainBeneficiaryError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

/** Request body for updating a blockchain beneficiary. Trust is granted only through the OTP trust step, and whitelisting is an operator designation, so the request carries no trusted or whitelisted flag; any field not declared here is dropped before the request reaches the journal-blockchain service, and the stored trusted, whitelisted and walletType are sent in their place. */
export interface UpdateBlockchainBeneficiaryPayload {
  customerReference?: string;
  nickname?: string;
  /** @format uuid */
  vasp?: string;
  /** Legal entity information for a blockchain beneficiary (person or corporation) */
  legalEntity?: {
    type: LegalEntityType;
    firstName?: string;
    lastName?: string;
    companyName?: string;
    department?: string;
    subDepartment?: string;
    streetName?: string;
    buildingNumber?: string;
    buildingName?: string;
    floor?: string;
    postBox?: string;
    room?: string;
    postCode?: string;
    townName: string;
    townLocationName?: string;
    districtName?: string;
    countrySubDivision?: string;
    addressLine?: string[];
    /** ISO 3166-1 Alpha-2 country code */
    country: string;
  };
  active?: boolean;
  comment?: string;
}

export interface UpdateBlockchainBeneficiaryParams {
  /** @format uuid */
  uuid: string;
}

/**
 * IdOnlyResponse
 * Minimal mutation response containing only the resource identifier. Used for fire-and-forget mutations where the client relies on cache invalidation rather than the response body.
 */
export interface UpdateBlockchainBeneficiaryData {
  /** @format uuid */
  id: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type UpdateBlockchainBeneficiaryError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface DeleteBlockchainBeneficiaryParams {
  /** @format uuid */
  uuid: string;
}

/**
 * IdOnlyResponse
 * Minimal mutation response containing only the resource identifier. Used for fire-and-forget mutations where the client relies on cache invalidation rather than the response body.
 */
export interface DeleteBlockchainBeneficiaryData {
  /** @format uuid */
  id: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type DeleteBlockchainBeneficiaryError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

/** SendOtp.response */
export interface SendRegistrationEmailOtpData {
  message?: string;
  /** @format int32 */
  expiresIn?: number;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type SendRegistrationEmailOtpError = {
  /**
   * @format int32
   * @min 400
   * @default 400
   */
  status: number;
  /** @deprecated */
  error?: string;
  /**
   * Human readable description of the type of exception.
   * @example "Unsupported currency"
   */
  message?: string;
  /**
   * Human readable description of the exception instance.
   * @example ["Cannot purchase RUB"]
   */
  messages?: string[];
  /** The name of the service that was the original source or cause of events, commands, or exceptions. */
  origin: string;
  /**
   * Type of the exception unique to the originating service. Imparts no
   * information for a particular exception instance. Intended to be used with
   * the parameters property for localisation of the exception message.
   * @default "service-exception"
   * @example "currency-not-supported"
   */
  type: string;
  /** Correlation id for the request. This is the OpenTelemetry span id. */
  spanId?: string;
  /** @example {"currency":"RUB"} */
  parameters?: Record<string, string>;
};

/** VerifyOtp.response */
export interface VerifyRegistrationEmailOtpData {
  verificationToken?: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type VerifyRegistrationEmailOtpError = {
  /**
   * @format int32
   * @min 400
   * @default 400
   */
  status: number;
  /** @deprecated */
  error?: string;
  /**
   * Human readable description of the type of exception.
   * @example "Unsupported currency"
   */
  message?: string;
  /**
   * Human readable description of the exception instance.
   * @example ["Cannot purchase RUB"]
   */
  messages?: string[];
  /** The name of the service that was the original source or cause of events, commands, or exceptions. */
  origin: string;
  /**
   * Type of the exception unique to the originating service. Imparts no
   * information for a particular exception instance. Intended to be used with
   * the parameters property for localisation of the exception message.
   * @default "service-exception"
   * @example "currency-not-supported"
   */
  type: string;
  /** Correlation id for the request. This is the OpenTelemetry span id. */
  spanId?: string;
  /** @example {"currency":"RUB"} */
  parameters?: Record<string, string>;
};

export type SendRegistrationSmsOtpData = SendOtpResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type SendRegistrationSmsOtpError = {
  /**
   * @format int32
   * @min 400
   * @default 400
   */
  status: number;
  /** @deprecated */
  error?: string;
  /**
   * Human readable description of the type of exception.
   * @example "Unsupported currency"
   */
  message?: string;
  /**
   * Human readable description of the exception instance.
   * @example ["Cannot purchase RUB"]
   */
  messages?: string[];
  /** The name of the service that was the original source or cause of events, commands, or exceptions. */
  origin: string;
  /**
   * Type of the exception unique to the originating service. Imparts no
   * information for a particular exception instance. Intended to be used with
   * the parameters property for localisation of the exception message.
   * @default "service-exception"
   * @example "currency-not-supported"
   */
  type: string;
  /** Correlation id for the request. This is the OpenTelemetry span id. */
  spanId?: string;
  /** @example {"currency":"RUB"} */
  parameters?: Record<string, string>;
};

export type VerifyRegistrationSmsOtpData = VerifyOtpResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type VerifyRegistrationSmsOtpError = {
  /**
   * @format int32
   * @min 400
   * @default 400
   */
  status: number;
  /** @deprecated */
  error?: string;
  /**
   * Human readable description of the type of exception.
   * @example "Unsupported currency"
   */
  message?: string;
  /**
   * Human readable description of the exception instance.
   * @example ["Cannot purchase RUB"]
   */
  messages?: string[];
  /** The name of the service that was the original source or cause of events, commands, or exceptions. */
  origin: string;
  /**
   * Type of the exception unique to the originating service. Imparts no
   * information for a particular exception instance. Intended to be used with
   * the parameters property for localisation of the exception message.
   * @default "service-exception"
   * @example "currency-not-supported"
   */
  type: string;
  /** Correlation id for the request. This is the OpenTelemetry span id. */
  spanId?: string;
  /** @example {"currency":"RUB"} */
  parameters?: Record<string, string>;
};

export type RegisterData = RegisterResponse;

/**
 * ExceptionDetail
 * Contains error message
 */
export type RegisterError = {
  /**
   * @format int32
   * @min 400
   * @default 400
   */
  status: number;
  /** @deprecated */
  error?: string;
  /**
   * Human readable description of the type of exception.
   * @example "Unsupported currency"
   */
  message?: string;
  /**
   * Human readable description of the exception instance.
   * @example ["Cannot purchase RUB"]
   */
  messages?: string[];
  /** The name of the service that was the original source or cause of events, commands, or exceptions. */
  origin: string;
  /**
   * Type of the exception unique to the originating service. Imparts no
   * information for a particular exception instance. Intended to be used with
   * the parameters property for localisation of the exception message.
   * @default "service-exception"
   * @example "currency-not-supported"
   */
  type: string;
  /** Correlation id for the request. This is the OpenTelemetry span id. */
  spanId?: string;
  /** @example {"currency":"RUB"} */
  parameters?: Record<string, string>;
};

export type GetPhonePrefixesData = PhonePrefix[];

export type GetRegistrationsData = RegistrationPage;

export type CreateKycAccessTokenData = KycAccessTokenResponse;

export type CreateKycAccessTokenError = ExceptionDetail;

export interface GetCustomerAccountApplicationsParams {
  "filter[applicationState]"?: ApplicationState[];
}

export type GetCustomerAccountApplicationsData = CustomerAccountApplicationPage;

export type GetCustomerAccountApplicationsError = ExceptionDetail;

export type CreateCustomerAccountApplicationData = CustomerAccountApplication;

/**
 * ExceptionDetail
 * Contains error message
 */
export type CreateCustomerAccountApplicationError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetCustomerAccountApplicationParams {
  /** @format uuid */
  applicationId: string;
}

/** CustomerAccountApplication */
export interface GetCustomerAccountApplicationData {
  /** @format uuid */
  id?: string;
  applicationType?: ApplicationType;
  applicationState?: ApplicationState;
  requiresDigitalAssets?: boolean;
  /**
   * @minLength 1
   * @maxLength 256
   */
  silo?: string;
  formData?: ApplicationFormData;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export type GetCustomerAccountApplicationError = ExceptionDetail;

export interface UpdateCustomerAccountApplicationParams {
  /** @format uuid */
  applicationId: string;
}

/** CustomerAccountApplication */
export interface UpdateCustomerAccountApplicationData {
  /** @format uuid */
  id?: string;
  applicationType?: ApplicationType;
  applicationState?: ApplicationState;
  requiresDigitalAssets?: boolean;
  /**
   * @minLength 1
   * @maxLength 256
   */
  silo?: string;
  formData?: ApplicationFormData;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type UpdateCustomerAccountApplicationError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface SubmitCustomerAccountApplicationParams {
  /** @format uuid */
  applicationId: string;
}

/** CustomerAccountApplication */
export interface SubmitCustomerAccountApplicationData {
  /** @format uuid */
  id?: string;
  applicationType?: ApplicationType;
  applicationState?: ApplicationState;
  requiresDigitalAssets?: boolean;
  /**
   * @minLength 1
   * @maxLength 256
   */
  silo?: string;
  formData?: ApplicationFormData;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

/**
 * ExceptionDetail
 * Contains error message
 */
export type SubmitCustomerAccountApplicationError =
  | {
      /**
       * @format int32
       * @min 400
       * @default 400
       */
      status: number;
      /** @deprecated */
      error?: string;
      /**
       * Human readable description of the type of exception.
       * @example "Unsupported currency"
       */
      message?: string;
      /**
       * Human readable description of the exception instance.
       * @example ["Cannot purchase RUB"]
       */
      messages?: string[];
      /** The name of the service that was the original source or cause of events, commands, or exceptions. */
      origin: string;
      /**
       * Type of the exception unique to the originating service. Imparts no
       * information for a particular exception instance. Intended to be used with
       * the parameters property for localisation of the exception message.
       * @default "service-exception"
       * @example "currency-not-supported"
       */
      type: string;
      /** Correlation id for the request. This is the OpenTelemetry span id. */
      spanId?: string;
      /** @example {"currency":"RUB"} */
      parameters?: Record<string, string>;
    }
  | ExceptionDetail;

export interface GetTransactionRangesParams {
  /** ISO 4217 currency code (e.g., GBP, AED) */
  currency: string;
}

export type GetTransactionRangesData = TransactionRanges;

export type GetTransactionRangesError = ExceptionDetail;

export type GetBusinessTypesData = FilteredBusinessTypePage;

export type GetBusinessTypesError = ExceptionDetail;
